import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import commonTranslationRU from "../Locales/ru/common.json";
import AdminTranslationRU from "../Locales/ru/admin.json";
import challengerTranslationRU from "../Locales/ru/challenger.json";
import expertTranslationRU from "../Locales/ru/expert.json";
import secretaryTranslationRU from "../Locales/ru/secretary.json";
import sysadminTranslationRU from "../Locales/ru/sysadmin.json";
import faqTranslationRU from "../Locales/ru/faq.json";


import commonTranslationKZ from "../Locales/kz/common.json";
import AdminTranslationKZ from "../Locales/kz/admin.json";
import challengerTranslationKZ from "../Locales/kz/challenger.json";
import expertTranslationKZ from "../Locales/kz/expert.json";
import secretaryTranslationKZ from "../Locales/kz/secretary.json";
import sysadminTranslationKZ from "../Locales/kz/sysadmin.json";
import faqTranslationKZ from "../Locales/kz/faq.json";

const resources = {
  ru: {
    // Namspaces
    cm: commonTranslationRU,
    ch: challengerTranslationRU,
    ad: AdminTranslationRU,
    ex: expertTranslationRU,
    se: secretaryTranslationRU,
    sa: sysadminTranslationRU,
    fq: faqTranslationRU,
  },
  kz: {
    // Namspaces
    cm: commonTranslationKZ,
    ch: challengerTranslationKZ,
    ad: AdminTranslationKZ,
    ex: expertTranslationKZ,
    se: secretaryTranslationKZ,
    sa: sysadminTranslationKZ,
    fq: faqTranslationKZ,
  },
};

i18n
  // Подключение бэкенда i18next
  .use(Backend)
  // Автоматическое определение языка
  .use(LanguageDetector)
  // модуль инициализации
  .use(initReactI18next)
  .init({
    resources,
    // Стандартный язык
    fallbackLng: "kz",
    debug: false,
    defaultNS: "cm",
    // Распознавание и кэширование языковых кук
    detection: {
      order: ["localStorage"],
      cache: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
